import { render, staticRenderFns } from "./tagsAutocomplete.vue?vue&type=template&id=777c3fba&"
import script from "./tagsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./tagsAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports